export const getAgentDataWithoutExcludedKeys = (agentData, excludedKeys) => {
  return Object.keys(agentData).reduce((acc, key) => {
    if (!excludedKeys.includes(key)) {
      acc[key] = agentData[key];
    }
    return acc;
  }, {});
};
